import styled from 'styled-components';
import { DEVICES } from '_constants';
import { LinkElem } from 'modules/Header/styles';
import { UiColors } from 'assets/styles/old/global';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  background: ${UiColors.forestColor};
  padding: 0 20px 0 0;
`;

export const HeaderBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;

  ${LinkElem} {
    padding: 0 15px;
    height: 100%;
    margin: 0;
  }
  > img {
    margin: 0 0 0 22px;
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 54px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 899;
`;

export const Body = styled.div`
  position: fixed;
  display: ${({ isOpenMenu }) => (isOpenMenu ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px 20px 0;
  top: 54px;
  width: fit-content;
  max-height: calc(100vh - 54px);
  z-index: 900;
  left: 0;
  overflow-y: auto;
  background: #f7f2f0;
  color: ${UiColors.forestColor};
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
`;

export const RoutesWrapper = styled.nav`
  margin: 5px 0 20px;
`;

export const RoutesList = styled.ul`
  margin: 0;
  padding: 0;
`;
export const RoutesListItem = styled.li`
  margin: 0;
  padding: 0;
  list-style: none;
  min-height: 32px;
  display: flex;
  align-items: center;

  a {
    margin-left: 25px;
    color: ${UiColors.forestColor};
  }
`;

export const Wrapper = styled.div`
  display: none;
  align-items: center;

  @media ${DEVICES.header} {
    display: flex;
  }
`;
